import React, {Component} from 'react';
import TranslationsLandingView from "../views/TranslationsLandingView";
import {Loading, withCourseStatisticsApi} from "cw-styleguide-react";

class TranslationsLandingController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    // Set the initial state of the form filter values.
    this.state = {
      summary: {},
      summaryLoaded: false,
    }
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.props.courseStatisticsApiGetSummary((response) => {

      this.setState({
        summary: {
          venues: response.data['Venues'],
          courses: response.data['Courses'],
          contacts: response.data['Contacts'],
        },
        summaryLoaded: true
      });
    }, (error) => {
      console.log(error);
    });


  }
    render() {
      // If the user is not logged in.
      if (!this.state.summaryLoaded ) {
        return <Loading/>
      }
    return <TranslationsLandingView  {...this.state} />;
  }
}

export default withCourseStatisticsApi(process.env)(TranslationsLandingController);
